import { VStack } from '@genial/components';
import React from 'react';

import { DynamicIOProductTableLoading } from '../DynamicIOProductTableLoading';

export const IOProductTablesLoading: React.FC = () => {
  return (
    <VStack>
      <DynamicIOProductTableLoading columnsCount={4} mobileDetailRowsCount={3} />
      <DynamicIOProductTableLoading columnsCount={3} mobileDetailRowsCount={2} />
      <DynamicIOProductTableLoading columnsCount={4} mobileDetailRowsCount={3} />
    </VStack>
  );
};
